import { Component, ContentChildren, Input, Optional, QueryList, Self, TemplateRef, ViewEncapsulation, forwardRef } from '@angular/core';
import { BankService } from '../../services/bank.service';
import { IBank } from '../../interfaces/bank';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgControl, ValidationErrors, Validator } from '@angular/forms';

@Component({
  selector: 'split-dropdown-bank',
  templateUrl: './split-dropdown-bank.component.html',
  styleUrls: ['./split-dropdown-bank.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SplitDropdownBankComponent),
      multi: true,
    },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => SplitDropdownBankComponent), multi: true },
  ],
  encapsulation: ViewEncapsulation.None
})
export class SplitDropdownBankComponent implements ControlValueAccessor, Validator {

  protected listBank: IBank[] = [];

  onChanged!: (stars: number) => void;
  onTouched!: () => void;

  protected disabled!: boolean;
  protected value!: any;
  protected control!: AbstractControl;
  
  constructor(private BankService: BankService) {}

  ngOnInit(): void {
    this.BankService.getAll().subscribe((response: any) => {
      this.listBank = response;
    });
  }

  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    console.log(control);
    this.control = control;
    return null;
  }

  onDropdownChange(value: any) {
    this.writeValue(value);
    this.onChanged(value);
    this.onTouched();
  }
}